import axios from 'axios';
import { AitGrKbn } from 'common/constant';
import { ResponseGenerator } from 'common/type';
import { getSignedUrlAPI } from 'modules/common/api';
import { getDetailUserMastApi } from 'modules/user-maintance/api';
import { call, put, takeLatest } from 'redux-saga/effects';

import {
  deleteChatroomAPI,
  deleteChatroomMemberAPI,
  deleteMessageAPI,
  deleteFileAPI,
  exportChatMessageAPI,
  getAllMessageAPI,
  getChatroomByKindAPI,
  getChatroomFileListAPI,
  getChatroomMemberAPI,
  getChatroomReadStatusAPI,
  getNoticeAPI,
  registerChatroomAPI,
  registerChatroomMemberAPI,
  registerFileAPI,
  registerFileMessageAPI,
  registerMessageAPI,
  registerNoticeAPI,
  updateChatroomAPI,
  updateChatroomReadStatusAPI,
  updateMessageAPI,
  updateNoticeAPI,
} from './api';
import {
  getChatroomFileList,
  getChatroomFileListSuccess,
  getChatroomFileListFailure,
  getChatroomByKind,
  getChatroomByKindFailure,
  getChatroomByKindSuccess,
  getChatroomMember,
  getChatroomMemberFailure,
  getChatroomMemberSuccess,
  getMessage,
  getMessageFailure,
  getMessageSuccess,
  updateMessageSuccess,
  updateMessageFailure,
  updateMessage,
  deleteMessageSuccess,
  deleteMessageFailure,
  deleteMessage,
  registerChatroomAuto,
  registerChatroomAutoSuccess,
  registerChatroomAutoFailure,
  updateChatroomSuccess,
  updateChatroomFailure,
  updateChatroom,
  registerFileSuccess,
  registerFileFailure,
  registerFile,
  registerNoticeMessage,
  getNotice,
  registerNoticeMessageSuccess,
  registerNoticeMessageFailure,
  getNoticeSuccess,
  getNoticeFailure,
  exportChatMessageFailure,
  exportChatMessageSuccess,
  exportChatMessage,
  getUserMastListSuccess,
  getUserMastListFailure,
  getUserMastList,
  deleteFile,
  deleteFileSuccess,
  deleteFileFailure,
} from './slice';

/**
 *
 * チャットルームメッセージ一覧取得処理
 *
 * - チャットルームIDに紐づくメッセージ一覧を取得
 * - メッセージを投稿時間の降順でソートする
 * - 通知の既読ステータスを更新する
 * - ユーザがチャットルームをどこまで読んだかを更新する
 *
 * @param param0
 */
function* getMessageSaga({ payload }: any) {
  try {
    let sortedList = [];
    // 対象チャットルームのメッセージを取得
    const getAllMessageResponse: ResponseGenerator = yield call(getAllMessageAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    if (
      getAllMessageResponse.data?.GetAllMessage?.items &&
      getAllMessageResponse.data?.GetAllMessage?.items.length > 0
    ) {
      sortedList = sortMessage(getAllMessageResponse.data?.GetAllMessage?.items);
      const latestItem = sortedList[0];
      if (payload.READ_MESSAGE_ID < latestItem.MESSAGE_ID) {
        // 対象ルームに通知が来ている場合は既読にする
        const response1: ResponseGenerator = yield call(getNoticeAPI, {
          params: {
            USER_ID: payload.EXECUTING_USER_ID,
            EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
          },
        });
        const noticeList = response1.data?.GetNotice?.items || [];
        for (const notice of noticeList) {
          if (notice.CHATROOM_ID === payload.CHATROOM_ID) {
            yield call(updateNoticeAPI, {
              params: {
                ID: notice.ID,
                EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
              },
            });
          }
        }
        // 既読IDの更新
        yield call(updateChatroomReadStatusAPI, {
          params: {
            CHATROOM_ID: payload.CHATROOM_ID,
            READ_MESSAGE_ID: latestItem.MESSAGE_ID,
            USER_ID: payload.USER_ID,
            EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
          },
        });
      }
    }
    yield put(getMessageSuccess(sortedList));
  } catch (error) {
    yield put(getMessageFailure({ loading: false }));
  }
}

/**
 * チャットルームメンバー一覧取得処理
 *
 * - チャットルームIDに紐づくメンバーを取得する
 * - DynamoDBから取得したメンバーはユーザIDしか持たないため、ユーザマスタから表示名を取得する
 *
 * @param param0
 */
function* getChatroomMemberSaga({ payload }: any) {
  try {
    // チャットルームのメンバー一覧の取得
    const getChatroomMemberResponse: ResponseGenerator = yield call(getChatroomMemberAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    const memberList = getChatroomMemberResponse.data?.GetChatroomMember?.items || [];
    // 取得したメンバー毎に名前を取得(getDetailUserMast)
    const updatedMemberList = [];
    for (let i = 0; i < memberList.length; i++) {
      const item = memberList[i];
      const USER_ID = item.USER_ID;
      const getDetailUserMastResponse: ResponseGenerator = yield call(getDetailUserMastApi, {
        USER_ID: USER_ID,
        IS_SIMPLE: '1',
      });
      if (getDetailUserMastResponse?.data) {
        const updatedItem = {
          ...item,
          USER_NM: getDetailUserMastResponse.data.USER_NM,
          AIT_USER_FLG: getDetailUserMastResponse.data.AIT_USER_FLG,
          DIVISION_CD: getDetailUserMastResponse.data.DIVISION_CD,
        };
        updatedMemberList.push(updatedItem);
      } else {
        memberList.splice(i, 1);
        i--;
        continue;
      }
    }
    yield put(getChatroomMemberSuccess(updatedMemberList));
  } catch (error) {
    yield put(getChatroomMemberFailure({ loading: false }));
  }
}

/**
 * チャットメッセージ更新処理
 *
 * - チャットメッセージを更新する
 *
 * @param param0
 */
function* updateMessageSaga({ payload }: any) {
  try {
    const updateMessageResponse: ResponseGenerator = yield call(updateMessageAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        MESSAGE_ID: payload.MESSAGE_ID,
        MESSAGE_BODY: payload.MESSAGE_BODY,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    yield put(updateMessageSuccess(updateMessageResponse.data?.UpdateMessage));
  } catch (error) {
    yield put(updateMessageFailure({ loading: false }));
  }
}

/**
 * チャットメッセージ削除処理
 *
 * - チャットメッセージを削除する
 *
 * @param param0
 */
function* deleteMessageSaga({ payload }: any) {
  try {
    const deleteMessageResponse: ResponseGenerator = yield call(deleteMessageAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        MESSAGE_ID: payload.MESSAGE_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    yield put(deleteMessageSuccess(deleteMessageResponse.data?.DeleteMessage));
  } catch (error) {
    yield put(deleteMessageFailure({ loading: false }));
  }
}

/**
 * チャットルーム自動作成処理（貨物トレースチャット）
 *
 * @param param0
 */
function* registerChatroomAutoSaga({ payload }: any) {
  try {
    yield upsertChatroomAndMember(
      {
        targets: [
          {
            kind: payload.KIND_INHOUSE,
            addUsers: payload.MEMBER?.filter(
              (member: any) => member?.PIC_GR_KBN !== AitGrKbn.SHIPPER_GR && member?.AIT_USER_FLG === '1'
            ),
          },
          {
            kind: payload.KIND_CLIENT,
            addUsers: payload.MEMBER?.filter(
              (member: any) =>
                member?.PIC_GR_KBN !== AitGrKbn.LODING_POL_GR &&
                member?.PIC_GR_KBN !== AitGrKbn.OCEAN_GR &&
                member?.PIC_GR_KBN !== AitGrKbn.CUST_CLEAR_GR
            ),
          },
        ],
        key: { ...payload },
        executeUserId: payload.EXECUTING_USER_ID,
      },
      (payload) => registerChatroomAutoSuccess(payload)
    );
  } catch (error) {
    yield put(registerChatroomAutoFailure({ loading: false, message: error }));
  }
}

/**
 * チャットルーム更新処理
 *
 * - チャットルーム名称を更新する
 * - 参加メンバーの削除/登録を行う
 *      - 全メンバーが削除されている場合、チャットルームを論理削除する（※チャットルーム残してメンバー削除すべきでは？）
 *
 * @param param0
 */
function* updateChatroomSaga({ payload }: any) {
  try {
    const updateChatroomResponse: ResponseGenerator = yield call(updateChatroomAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        NAME: payload.NAME,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    // ユーザ全削除の場合は、ユーザ登録/削除ではなくルームの削除を行う
    // if (payload.MEMBER.every((item: { DEL_FLG: string }) => item.DEL_FLG === '1')) {
    //   yield call(deleteChatroomAPI, {
    //     params: {
    //       CHATROOM_ID: payload.CHATROOM_ID,
    //       EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
    //     },
    //   });
    // } else {
    // ユーザの登録/削除
    for (const item of payload.MEMBER) {
      // 処理対象として定義したユーザのみを削除/更新を行う
      if (!item.TARGET) continue;
      if (item.DEL_FLG === '0') {
        yield call(registerChatroomMemberAPI, {
          params: {
            USER_ID: item.USER_ID,
            CHATROOM_ID: updateChatroomResponse.data?.UpdateChatroom.CHATROOM_ID,
            KIND: updateChatroomResponse.data?.UpdateChatroom.KIND,
            READ_MESSAGE_ID: 0,
            EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
          },
        });
      } else {
        yield call(deleteChatroomMemberAPI, {
          params: {
            USER_ID: item.USER_ID,
            CHATROOM_ID: updateChatroomResponse.data?.UpdateChatroom.CHATROOM_ID,
            EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
          },
        });
      }
    }
    // }
    yield put(updateChatroomSuccess(updateChatroomResponse));
  } catch (error) {
    yield put(updateChatroomFailure({ loading: false }));
  }
}

/**
 * チャット添付ファイル登録処理
 *
 * - ファイル名をチャットメッセージとして登録する
 * - ファイルのパスをチャット添付ファイルとして登録する
 * - 添付ファイルをS3へ登録する
 * - 登録後のメッセージ一覧を取得する（投稿日の降順でソート）
 * - 既読フラグ／最後に読んだところを更新する
 *
 * @param param0
 */
function* registerFileSaga({ payload }: any) {
  try {
    // メッセージとして登録
    const registerFileMessageResponse: ResponseGenerator = yield call(registerFileMessageAPI, {
      params: {
        ADD_USER_ID: payload.USER_ID,
        ADD_USER_NM: payload.USER_NM,
        CHATROOM_ID: payload.CHATROOM_ID,
        FILE_NAME: payload.FILE.name,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    // ファイル情報のDBへの登録
    const regMessage = registerFileMessageResponse.data?.RegisterFileMessage;
    yield call(registerFileAPI, {
      params: {
        ADD_USER_ID: regMessage.ADD_USER_ID,
        ADD_USER_NM: regMessage.ADD_USER_NM,
        CHATROOM_ID: regMessage.CHATROOM_ID,
        MESSAGE_ID: regMessage.MESSAGE_ID,
        NAME: regMessage.MESSAGE_BODY,
        PATH: `${process.env.REACT_APP_CHAT_S3_DIRECTORY}/${regMessage.CHATROOM_ID}/${regMessage.MESSAGE_ID}`,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    // ファイルの登録用署名付きURLの取得
    const getSignedUrlResponse: ResponseGenerator = yield call(getSignedUrlAPI, {
      filePath: `${process.env.REACT_APP_CHAT_S3_DIRECTORY}/${regMessage.CHATROOM_ID}/${regMessage.MESSAGE_ID}`,
      fileName: payload.FILE.name,
      upload: '1',
    });
    // 署名付きURLを使ったファイルのS3への登録
    yield axios.put(getSignedUrlResponse.data, payload.FILE, {
      headers: {
        'Content-Type': payload.FILE.type,
      },
    });

    let sortedList = [];
    // 対象チャットルームのメッセージを取得
    const getAllMessageResponse: ResponseGenerator = yield call(getAllMessageAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    if (getAllMessageResponse.data?.GetAllMessage?.items) {
      // 対象ルームに通知が来ている場合は既読にする
      const getNoticeResponse: ResponseGenerator = yield call(getNoticeAPI, {
        params: {
          USER_ID: payload.EXECUTING_USER_ID,
          EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
        },
      });
      const noticeList = getNoticeResponse.data?.GetNotice?.items || [];
      for (const notice of noticeList) {
        if (notice.CHATROOM_ID === payload.CHATROOM_ID) {
          yield call(updateNoticeAPI, {
            params: {
              ID: notice.ID,
              EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
            },
          });
        }
      }
      sortedList = sortMessage(getAllMessageResponse.data?.GetAllMessage?.items);
      const latestItem = sortedList[0];
      yield call(updateChatroomReadStatusAPI, {
        params: {
          CHATROOM_ID: payload.CHATROOM_ID,
          READ_MESSAGE_ID: latestItem.MESSAGE_ID,
          USER_ID: payload.USER_ID,
          EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
        },
      });
    }
    yield put(registerFileSuccess(sortedList));
  } catch (error) {
    yield put(registerFileFailure({ loading: false }));
  }
}

/**
 * チャットメッセージ登録（通知あり）
 *
 * - チャットルームに対してチャットメッセージを登録する
 * - メンション先のメンバーに対して通知情報を登録する
 * - 登録後のメッセージ一覧を取得する（投稿日の降順でソート）
 * - 既読フラグ／最後に読んだところを更新する
 *
 * @param param0
 */
function* registerNoticeMessageSaga({ payload }: any) {
  try {
    // メッセージとして登録
    const registerMessageResponse: ResponseGenerator = yield call(registerMessageAPI, {
      params: {
        ADD_USER_ID: payload.ADD_USER_ID,
        ADD_USER_NM: payload.ADD_USER_NM,
        CHATROOM_ID: payload.CHATROOM_ID,
        MESSAGE_BODY: payload.MESSAGE_BODY,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    const messageId = registerMessageResponse.data?.RegisterMessage.MESSAGE_ID;

    // 宛先毎に通知を登録する
    for (const mention of payload.MENTIONS) {
      yield call(registerNoticeAPI, {
        params: {
          USER_ID: mention,
          CHATROOM_ID: payload.CHATROOM_ID,
          MESSAGE_ID: messageId,
          EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
        },
      });
    }
    // 対象チャットルームのメッセージを取得
    const getAllMessageResponse: ResponseGenerator = yield call(getAllMessageAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    // 既読IDの更新
    yield call(updateChatroomReadStatusAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        READ_MESSAGE_ID: messageId,
        USER_ID: payload.ADD_USER_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    // 対象ルームに通知が来ている場合は既読にする
    const getNoticeResponse: ResponseGenerator = yield call(getNoticeAPI, {
      params: {
        USER_ID: payload.EXECUTING_USER_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    const sortedList = sortMessage(getAllMessageResponse.data?.GetAllMessage?.items);
    const noticeList = getNoticeResponse.data?.GetNotice?.items || [];
    for (const notice of noticeList) {
      if (notice.CHATROOM_ID === payload.CHATROOM_ID) {
        yield call(updateNoticeAPI, {
          params: {
            ID: notice.ID,
            EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
          },
        });
      }
    }
    yield put(registerNoticeMessageSuccess(sortedList));
  } catch (error) {
    yield put(registerNoticeMessageFailure({ loading: false }));
  }
}

/**
 * 通知情報取得処理
 *
 * - ユーザに紐づく通知情報を取得する
 * - チャットルームごとにリスト化する
 *
 * @param param0
 */
function* getNoticeSaga({ payload }: any) {
  try {
    const getNoticeResponse: ResponseGenerator = yield call(getNoticeAPI, {
      params: {
        USER_ID: payload.USER_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    const noticeList = getNoticeResponse.data?.GetNotice?.items || [];

    // チャットルーム毎にリスト化する
    const outputObject: Record<string, any> = {};
    for (const entry of noticeList) {
      const { CHATROOM_ID } = entry;
      outputObject[CHATROOM_ID] = outputObject[CHATROOM_ID] || [];
      outputObject[CHATROOM_ID].push(entry);
    }
    const resultArray = Object.entries(outputObject).map(([key, value]) => ({ [key]: value }));

    yield put(getNoticeSuccess(resultArray));
  } catch (error) {
    yield put(getNoticeFailure({ loading: false }));
  }
}

/**
 * チャット添付ファイル一覧取得処理
 *
 * - 添付ファイルの一覧を取得する
 * - 投稿日の降順でソートする
 *
 * @param param0
 */
function* getChatroomFileListSaga({ payload }: any) {
  try {
    const getChatroomFileListResponse: ResponseGenerator = yield call(getChatroomFileListAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    const sortedList = sortMessage(getChatroomFileListResponse.data?.GetChatroomFileList?.items);
    yield put(getChatroomFileListSuccess(sortedList || []));
  } catch (error) {
    yield put(getChatroomFileListFailure({ loading: false }));
  }
}

/**
 * チャットルーム一覧検索（※KINDは検索条件に含まれない）
 *
 * - キー情報に紐づくチャットルームの一覧を取得する
 * - ログインユーザがチャットルームに参加しているか確認しレスポンスに設定する
 *     - 参加している場合、どこまで既読なのかを取得して設定する
 *
 * @param param0
 */
function* getChatroomByKindSaga({ payload }: any) {
  try {
    const chatroom: any = [];
    const getChatroomByKindResponse: ResponseGenerator = yield call(getChatroomByKindAPI, {
      params: {
        KEY: payload.KEY,
        SUB_KEY: payload.SUB_KEY,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
        // KIND: payload.KIND
      },
    });
    const serachDatas = getChatroomByKindResponse.data?.GetChatroomByKind?.items || [];
    const serachData = serachDatas.find((sd: any) => sd.KIND === payload.KIND && sd.DELETE_FLG !== '1');
    // 対象のチャットルームが取得出来ている場合、自身が対象のチャットルームに参加しているかを確認
    if (serachData) {
      // 削除されている場合は確認しない
      const getChatroomReadStatusResponse: ResponseGenerator = yield call(getChatroomReadStatusAPI, {
        params: {
          CHATROOM_ID: serachData.CHATROOM_ID,
          USER_ID: payload.USER_ID,
          EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
        },
      });
      if (getChatroomReadStatusResponse.data?.GetChatroomReadStatus) {
        serachData.USER_ID = getChatroomReadStatusResponse.data?.GetChatroomReadStatus.USER_ID;
        serachData.READ_MESSAGE_ID = getChatroomReadStatusResponse.data?.GetChatroomReadStatus.READ_MESSAGE_ID;
        serachData.IS_CHAT_MEMBER = true;
      } else {
        serachData.IS_CHAT_MEMBER = false;
      }
      chatroom.push(serachData);
    }
    yield put(getChatroomByKindSuccess(chatroom));
  } catch (error) {
    yield put(getChatroomByKindFailure({ loading: false }));
  }
}

/**
 * チャットメッセージエクスポート処理
 *
 * @param param0
 */
function* exportChatMessageSaga({ payload }: any) {
  try {
    const exportChatMessageResponse: ResponseGenerator = yield call(exportChatMessageAPI, { params: payload });
    if (exportChatMessageResponse.results.code === 9) {
      yield put(exportChatMessageFailure({ message: exportChatMessageResponse.results.message, loading: false }));
    }
    yield put(exportChatMessageSuccess(exportChatMessageResponse));
  } catch (error) {
    yield put(exportChatMessageFailure({ loading: false }));
  }
}

/**
 * ユーザ表示名取得処理
 *
 * @param param0
 */
function* getUserMastListSaga({ payload }: any) {
  try {
    const updatedMemberList = [];
    for (const USER_ID of payload) {
      const getDetailUserMastResponse: ResponseGenerator = yield call(getDetailUserMastApi, {
        USER_ID: USER_ID,
        IS_SIMPLE: '1',
      });
      if (getDetailUserMastResponse.data) {
        updatedMemberList.push({
          USER_ID: getDetailUserMastResponse.data.USER_ID,
          USER_NM: getDetailUserMastResponse.data.USER_NM,
        });
      }
    }
    yield put(getUserMastListSuccess(updatedMemberList));
  } catch (error) {
    yield put(getUserMastListFailure({ loading: false }));
  }
}

/**
 * チャットルーム登録／更新処理
 *
 * - 対象のチャットルームが存在するか確認を行い存在しない場合チャットルームを登録する
 * - 参加ユーザを取得してユーザーの登録／削除を行う
 *
 * @param chatroomInfo チャットルーム情報
 * @param successCallBack 成功時のコールバック関数（更新の有無を設定）
 */
export function* upsertChatroomAndMember(
  chatroomInfo: {
    targets: {
      kind: string;
      addUsers: { USER_ID: string }[];
      deleteUsers?: { USER_ID: string }[];
    }[];
    key: { KEY: string; SUB_KEY?: string };
    executeUserId: string;
  },
  successCallBack?: (payload: any) => { payload: any; type: string }
) {
  // チャットルームの更新を行ったか
  let isUpdateChatRoom = false;

  for (const target of chatroomInfo.targets) {
    let chatroomId: string;
    // 対象チャットルームのIDを取得
    const getChatroomByKindResponse: ResponseGenerator = yield call(getChatroomByKindAPI, {
      params: {
        KEY: chatroomInfo.key.KEY,
        EXECUTING_USER_ID: chatroomInfo.executeUserId,
      },
    });

    // 対象区分のチャットルームが存在するか確認
    const chatroomKind = getChatroomByKindResponse.data?.GetChatroomByKind?.items?.find(
      (i: { KIND: string }) => i.KIND === target.kind
    );
    chatroomId = chatroomKind?.CHATROOM_ID;
    // チャットルームが存在しない場合、チャットルームを作成する
    if (!chatroomKind) {
      isUpdateChatRoom = true;
      // 通関依頼(社内)のチャットルーム作成処理
      const registerChatroomResponse: ResponseGenerator = yield call(registerChatroomAPI, {
        params: {
          KEY: chatroomInfo.key.KEY,
          SUB_KEY: chatroomInfo.key.SUB_KEY,
          KIND: target.kind,
          NAME: chatroomInfo.key.KEY,
          EXECUTING_USER_ID: chatroomInfo.executeUserId,
        },
      });
      chatroomId = registerChatroomResponse.data?.RegisterChatroom.CHATROOM_ID;
    }

    // チャットルームの参加者一覧を取得
    const getChatroomMemberResponse: ResponseGenerator = yield call(getChatroomMemberAPI, {
      params: {
        CHATROOM_ID: chatroomId,
        EXECUTING_USER_ID: chatroomInfo.executeUserId,
      },
    });
    const memberList = getChatroomMemberResponse.data?.GetChatroomMember?.items || [];

    // チャット参加者の存在チェック処理
    const isExistUser = (memberList: any[], targetUser: { USER_ID: string }) => {
      return memberList.some((user: { USER_ID: any }) => user.USER_ID === targetUser.USER_ID);
    };

    // チャットルームへユーザーを追加
    for (const addUser of target.addUsers) {
      // チャットルームに参加者として存在する場合はユーザー登録を行わない
      if (isExistUser(memberList, addUser)) continue;
      isUpdateChatRoom = true;
      yield call(registerChatroomMemberAPI, {
        params: {
          USER_ID: addUser.USER_ID,
          CHATROOM_ID: chatroomId,
          KIND: target.kind,
          READ_MESSAGE_ID: 0,
          EXECUTING_USER_ID: chatroomInfo.executeUserId,
        },
      });
    }

    // チャットルームからユーザ削除処理
    for (const deleteUser of target.deleteUsers || []) {
      // チャットルームに参加者として存在しない場合はユーザ削除を行わない
      if (!isExistUser(memberList, deleteUser)) continue;
      isUpdateChatRoom = true;
      yield call(deleteChatroomMemberAPI, {
        params: {
          USER_ID: deleteUser.USER_ID,
          CHATROOM_ID: chatroomId,
          EXECUTING_USER_ID: chatroomInfo.executeUserId,
        },
      });
    }
  }

  if (successCallBack) yield put(successCallBack(isUpdateChatRoom));
}

/**
 * チャットメッセージソート処理
 * @param messageList メッセージ一覧
 * @returns ソート済みメッセージ一覧
 */
function sortMessage(messageList: any[] | undefined): any[] {
  return [...(messageList || [])].sort((a, b) => a.MESSAGE_ID - b.MESSAGE_ID);
}

function* deleteFileSaga({ payload }: any) {
  try {
    const deleteFileResponse: ResponseGenerator = yield call(deleteFileAPI, {
      params: {
        CHATROOM_ID: payload.CHATROOM_ID,
        MESSAGE_ID: payload.MESSAGE_ID,
        EXECUTING_USER_ID: payload.EXECUTING_USER_ID,
      },
    });
    yield put(deleteFileSuccess(deleteFileResponse));
  } catch (error) {
    yield put(deleteFileFailure({ loading: false }));
  }
}

function* watcChatroomInformation() {
  yield takeLatest(getChatroomFileList, getChatroomFileListSaga);
  yield takeLatest(getChatroomByKind, getChatroomByKindSaga);
  yield takeLatest(getChatroomMember, getChatroomMemberSaga);
  yield takeLatest(getMessage, getMessageSaga);
  yield takeLatest(updateMessage, updateMessageSaga);
  yield takeLatest(deleteMessage, deleteMessageSaga);
  yield takeLatest(registerChatroomAuto, registerChatroomAutoSaga);
  yield takeLatest(updateChatroom, updateChatroomSaga);
  yield takeLatest(registerFile, registerFileSaga);
  yield takeLatest(registerNoticeMessage, registerNoticeMessageSaga);
  yield takeLatest(getNotice, getNoticeSaga);
  yield takeLatest(exportChatMessage, exportChatMessageSaga);
  yield takeLatest(getUserMastList, getUserMastListSaga);
  yield takeLatest(deleteFile, deleteFileSaga);
}

export default watcChatroomInformation;
